import React from 'react';
import { Route, Switch, Redirect } from 'react-router';
import { isSafari } from 'react-device-detect';

import Account from 'pages/Account';
import AccountIndex from 'pages/Account/AccountIndex';
import SettingsIndex from 'pages/Account/Settings/SettingsIndex';
import Cms from 'pages/Account/Cms';
import CmsDetails from 'pages/Account/CmsDetails';
import CmsElements from 'pages/Account/Settings/CmsElements';
import CmsElementDetails from 'pages/Account/Settings/CmsElementDetails';
import Pipelines from 'pages/Account/Settings/Pipelines';
import PipelineDetails from 'pages/Account/Settings/PipelineDetails';
import Templates from 'pages/Account/Settings/Templates';
import Questionnaires from 'pages/Account/Settings/Questionnaires';
import QuestionnaireDetails from 'pages/Account/Settings/QuestionnaireDetails';
import Profile from 'pages/Account/Settings/Profile';
import Locations from 'pages/Account/Settings/Locations';
import Invoices from 'pages/Account/Settings/Invoices';
import InvoiceDetails from 'pages/Account/Settings/InvoiceDetails';
import Clients from 'pages/Account/Clients';
import ClientDetails from 'pages/Account/ClientDetails';
import Calendar from 'pages/Account/Calendar';
import Payments from 'pages/Account/Payments';
import Items from 'pages/Account/Items';
import Item from 'pages/Account/Item';
import Users from 'pages/Account/Settings/Users';
import UsersImport from 'pages/Account/Settings/UsersImport';
import UsersRemove from 'pages/Account/Settings/UsersRemove';
import UserDetails from 'pages/Account/Settings/UserDetails';
import DynamicDataDefinitions from 'pages/Account/Settings/DynamicDataDefinitions';
import DynamicDataDefinitionDetails from 'pages/Account/Settings/DynamicDataDefinitionDetails';
import DocTypes from 'pages/Account/Settings/DocTypes';
import DocTypeDetails from 'pages/Account/Settings/DocTypeDetails';
import DocTemplates from 'pages/Account/Settings/DocTemplates';
import DocTemplateDetails from 'pages/Account/Settings/DocTemplateDetails';
import Teams from 'pages/Account/Settings/Teams';
import TeamDetails from 'pages/Account/Settings/TeamDetails';
import Brands from 'pages/Account/Settings/Brands';
import Models from 'pages/Account/Settings/Models';
import ModelGroups from 'pages/Account/Settings/ModelGroups';
import ModelGroupDetails from 'pages/Account/Settings/ModelGroupDetails';
import ModelAssets from 'pages/Account/Settings/ModelAssets';
import ModelAssetDetails from 'pages/Account/Settings/ModelAssetDetails';
import Categories from 'pages/Account/Settings/Categories';
import CategoryDetails from 'pages/Account/Settings/CategoryDetails';
import Attributes from 'pages/Account/Settings/Attributes';
import AttributeDetails from 'pages/Account/Settings/AttributeDetails';
import AttributeGroups from 'pages/Account/Settings/AttributeGroups';
import DataPush from 'pages/Account/Settings/DataPush';
import WhiteLabel from 'pages/Account/Settings/WhiteLabel';
import WhiteLabelDetails from 'pages/Account/Settings/WhiteLabelDetails';
import WhiteLabelCmsDetails from 'pages/Account/Settings/WhiteLabelCmsDetails';
import WhiteLabelPlugin from 'pages/Account/Settings/WhiteLabelPlugin';
import WhiteLabelPluginDetails from 'pages/Account/Settings/WhiteLabelPluginDetails';
import Plugins from 'pages/Account/Settings/Plugins';
import LeadCatchers from 'pages/Account/Settings/LeadCatchers';
import LeadCatcherDetails from 'pages/Account/Settings/LeadCatcherDetails';
import Integrations from 'pages/Account/Settings/Integrations';
import MyCompany from 'pages/Account/Settings/MyCompany';
import PluginActivateDetails from 'pages/Account/Settings/PluginActivateDetails';
import PluginSepaDetails from 'pages/Account/Settings/PluginSepaDetails';
import SepaAgreements from 'pages/Account/Settings/SepaAgreements';
import LeadPerMailRules from 'pages/Account/Settings/LeadPerMailRules';
import LeadPerMailRuleDetails from 'pages/Account/Settings/LeadPerMailRuleDetails';
import Leads from 'pages/Account/Leads';
import LeadStatistics from 'pages/Account/LeadStatistics';
import LeadDetails from 'pages/Account/LeadDetails';
import Orders from 'pages/Account/Orders';
import OrderDetails from 'pages/Account/OrderDetails';
import OrderDetailsIndex from 'pages/Account/Order/OrderDetailsIndex';
import VendorOrders from 'pages/Account/VendorOrders';
import VendorOrderDetails from 'pages/Account/VendorOrderDetails';
import VendorOrderDetailsIndex from 'pages/Account/VendorOrderDetailsIndex';
import CreateDelivery from 'pages/Account/Order/CreateDelivery';
import FailedRefunds from 'pages/Account/Settings/FailedRefunds';
import Communities from 'pages/Account/Settings/Communities';
import Updates from 'pages/Account/Settings/Updates';
import CmsTemplates from 'pages/Account/Settings/CmsTemplates';
import CmsTemplateDetails from 'pages/Account/Settings/CmsTemplateDetails';
import LeadAutoresponses from 'pages/Account/Settings/LeadAutoresponses';
import LeadAutoresponseDetails from 'pages/Account/Settings/LeadAutoresponseDetails';
import MainMenuVersions from 'pages/Account/Settings/MainMenuVersions';
import MainMenuVersionDetails from 'pages/Account/Settings/MainMenuVersionDetails';
import LeadTaggers from 'pages/Account/Settings/LeadTaggers';
import LeadTaggerDetails from 'pages/Account/Settings/LeadTaggerDetails';
import LeadAssignmentStrategies from 'pages/Account/Settings/LeadAssignmentStrategies';
import LeadAssignmentStrategyDetails from 'pages/Account/Settings/LeadAssignmentStrategyDetails';
import LeadEscalationRules from 'pages/Account/Settings/LeadEscalationRules';
import LeadEscalationRuleDetails from 'pages/Account/Settings/LeadEscalationRuleDetails';
import ClientCars from 'pages/Account/ClientCars';
import ClientCarDetails from 'pages/Account/ClientCarDetails';
import Communication from 'pages/Account/Communication';
import ContactManagement from 'pages/Account/ContactManagement';
import Coupons from 'pages/Account/Settings/Coupons';
import CouponDetails from 'pages/Account/Settings/CouponDetails';

import SalesActivityDashboardView from 'pages/VklBusinessesView';
import RentActivityDashboard from 'pages/RentActivityDashboard';
import Connectme from 'pages/Connectme';

import Campaigns from 'pages/Campaigns';
import CampaignDetails from 'components/layout/campaigns/CampaignDetails';
import MediaLibrary from 'pages/Account/MediaLibrary';
import TrashBin from 'pages/Account/TrashBin';
import Archive from 'pages/Account/Archive';
import ServiceTypes from 'pages/Account/Settings/ServiceTypes';
import ProvisionService from 'pages/Account/Settings/ProvisionService';
import CommissionServiceInvoices from 'pages/Account/Settings/CommissionServiceInvoices';
import CommissionInvoiceDetails from 'pages/Account/Settings/CommissionInvoiceDetails';

import Subscriptions from 'components/layout/subscriptions/Subscriptions';
import SubscriptionsForUser from 'components/layout/subscriptions/SubscriptionsForUser';
import ClientSubscriptions from 'components/layout/subscriptions/ClientSubscriptions';
import ProductGroups from 'pages/Account/Settings/ProductGroups';
import AllowedDomains from 'pages/Account/Settings/AllowedDomains';

const routeLangPrefix = '/:lang(de|en|pl|tr|nl|it|fr|es)?';
const prefix = `${routeLangPrefix}/account`;

const ProductTemplates = !isSafari ? React.lazy(() => import('./pages/Account/Settings/ProductTemplates')) : null;
const ProductTemplateDetails = !isSafari
  ? React.lazy(() => import('./pages/Account/Settings/ProductTemplateDetails'))
  : null;
const ArchivedProductTemplates = !isSafari ? React.lazy(() => import('./pages/Account/Settings/ArchivedProductTemplates')) : null;

export default function ClientAccountRoutes() {
  return (
    <Account>
      <Switch>
        <Route exact path={`${prefix}`} component={AccountIndex} />

        <Route exact path={`${prefix}/clients`} component={Clients} />
        <Route path={`${prefix}/clients/:clientId`} component={ClientDetails} />

        <Route path={`${prefix}/calendar`} component={Calendar} />

        <Route path={`${prefix}/media`} component={MediaLibrary} />
        <Route path={`${prefix}/trash`} component={TrashBin} />
        <Route path={`${prefix}/archive`} component={Archive} />

        <Route path={`${prefix}/settings/serviceTypes`} component={ServiceTypes} />
        <Route path={`${prefix}/settings/provisionService`} component={ProvisionService} />

        <Route exact path={`${prefix}/settings/commissionServiceInvoices`} component={CommissionServiceInvoices} />
        <Route path={`${prefix}/settings/commissionServiceInvoices/:invoiceId`} component={CommissionInvoiceDetails} />

        <Route path={`${prefix}/settings/subscriptions`} component={Subscriptions} />
        <Route path={`${prefix}/settings/subscriptionsforuser`} component={SubscriptionsForUser} />
        <Route path={`${prefix}/settings/clientsubscriptions`} component={ClientSubscriptions} />

        <Route path={`${prefix}/settings/productgroups`} component={ProductGroups} />

        <Route exact path={`${prefix}/leads`} component={Leads} />
        <Route exact path={`${prefix}/leads/statistics`} component={LeadStatistics} />
        <Route path={`${prefix}/leads/:leadId`} component={LeadDetails} />

        <Route exact path={`${prefix}/tasks`}>
          <Leads type="task" />
        </Route>
        <Route exact path={`${prefix}/tasks/statistics`}>
          <LeadStatistics type="task" />
        </Route>
        <Route path={`${prefix}/tasks/:leadId`}>
          <LeadDetails type="task" />
        </Route>

        <Route path={`${prefix}/contact-management`} component={ContactManagement} />

        <Route path={`${prefix}/settings/allowedDomains`} component={AllowedDomains} />

        <Route path={`${prefix}/payments`} component={Payments} />

        <Route exact path={`${prefix}/items`} component={Items} />

        <Route exact path={`${prefix}/items/:itemId`} render={() => <Item type="item" />} />
        <Route path={`${prefix}/items/:itemId/variants/:variantId`} render={() => <Item type="itemVariant" />} />
        <Route exact path={`${prefix}/vendororders`} component={VendorOrders} />
        <Route
          exact
          path={`${prefix}/vendororders/:orderId`}
          render={() => (
            <VendorOrderDetails>
              <VendorOrderDetailsIndex />
            </VendorOrderDetails>
          )}
        />
        <Route exact path={`${prefix}/campaigns`} component={Campaigns} />
        <Route exact path={`${prefix}/campaigns/:campaignId`} component={CampaignDetails} />

        <Route exact path={`${prefix}/orders`} component={Orders} />

        <Route
          path={`${prefix}/(orders|carServices)/:orderId`}
          render={() => (
            <Switch>
              <Route
                exact
                path={`${prefix}/(orders|carServices)/:orderId`}
                render={() => (
                  <OrderDetails>
                    <OrderDetailsIndex />
                  </OrderDetails>
                )}
              />

              <Route
                path={`${prefix}/orders/:orderId/createDelivery`}
                render={() => (
                  <OrderDetails>
                    <CreateDelivery />
                  </OrderDetails>
                )}
              />
            </Switch>
          )}
        />

        <Route exact path={`${prefix}/cms`} component={Cms} />
        <Route path={`${prefix}/cms/:cmsId`} component={CmsDetails} />

        <Route path={`${prefix}/profile`} component={Profile} />

        <Route path={[`${prefix}/communication/:activeChat`, `${prefix}/communication`]} component={Communication} />

        <Route path={`${prefix}/salesActivityDashboard`} component={SalesActivityDashboardView} />
        <Route path={`${prefix}/rentActivityDashboard`} component={RentActivityDashboard} />
        <Route path={`${prefix}/connectme`} component={Connectme} />

        <Route exact path={`${prefix}/myCars`} component={ClientCars} />
        <Route path={`${prefix}/myCars/:clientCarId`} component={ClientCarDetails} />

        <Route exact path={`${prefix}/settings`} component={SettingsIndex} />

        <Route exact path={`${prefix}/settings/pipelines`} component={Pipelines} />
        <Route path={`${prefix}/settings/pipelines/:pipelineId`} component={PipelineDetails} />

        <Route path={`${prefix}/settings/templates`} component={Templates} />

        <Route exact path={`${prefix}/settings/questionnaires`} component={Questionnaires} />
        <Route path={`${prefix}/settings/questionnaires/:questionnaireId`} component={QuestionnaireDetails} />

        <Route path={`${prefix}/settings/profile`} component={Profile} />

        <Route path={`${prefix}/settings/myCompany`} component={MyCompany} />

        <Route path={`${prefix}/settings/locations`} component={Locations} />

        {/* <Route path={`${prefix}/settings/products`} component={Products} /> */}

        <Route exact path={`${prefix}/settings/invoices`} component={Invoices} />
        <Route path={`${prefix}/settings/invoices/:invoiceId`} component={InvoiceDetails} />

        <Route exact path={`${prefix}/settings/users`} component={Users} />
        <Route path={`${prefix}/settings/users/:clientId`} component={UserDetails} />

        <Route exact path={`${prefix}/settings/usersimport`} component={UsersImport} />
        <Route exact path={`${prefix}/settings/usersremove`} component={UsersRemove} />

        <Route exact path={`${prefix}/settings/dataDefinitions`} component={DynamicDataDefinitions} />
        <Route path={`${prefix}/settings/dataDefinitions/:definitionId`} component={DynamicDataDefinitionDetails} />

        <Route exact path={`${prefix}/settings/docTypes`} component={DocTypes} />
        <Route path={`${prefix}/settings/docTypes/:docTypeId`} component={DocTypeDetails} />

        <Route exact path={`${prefix}/settings/teams`} component={Teams} />
        <Route path={`${prefix}/settings/teams/:teamId`} component={TeamDetails} />

        <Route path={`${prefix}/settings/brands`} component={Brands} />
        <Route exact path={`${prefix}/settings/producttemplates`} component={ProductTemplates} />
        <Route path={`${prefix}/settings/producttemplates/:productTemplateId`} component={ProductTemplateDetails} />

        <Route exact path={`${prefix}/settings/archivedproducttemplates`} component={ArchivedProductTemplates} />

        <Route path={`${prefix}/settings/models`} component={Models} />

        <Route exact path={`${prefix}/settings/modelGroups`} component={ModelGroups} />
        <Route path={`${prefix}/settings/modelGroups/:modelGroupId`} component={ModelGroupDetails} />

        <Route exact path={`${prefix}/settings/modelAssets`} component={ModelAssets} />
        <Route path={`${prefix}/settings/modelAssets/:modelAssetId`} component={ModelAssetDetails} />

        <Route exact path={`${prefix}/settings/categories`} component={Categories} />
        <Route path={`${prefix}/settings/categories/:categoryId`} component={CategoryDetails} />

        <Route exact path={`${prefix}/settings/attributes`} component={Attributes} />
        <Route path={`${prefix}/settings/attributes/:attributeId`} component={AttributeDetails} />

        <Route path={`${prefix}/settings/attributeGroups`} component={AttributeGroups} />

        <Route exact path={`${prefix}/settings/cmsElements`} component={CmsElements} />
        <Route path={`${prefix}/settings/cmsElements/:elementId`} component={CmsElementDetails} />

        <Route path={`${prefix}/settings/dataPush`} component={DataPush} />

        <Route exact path={`${prefix}/settings/whiteLabel`} component={WhiteLabel} />
        <Route exact path={`${prefix}/settings/whiteLabel/:whiteLabelId`} component={WhiteLabelDetails} />
        <Route exact path={`${prefix}/settings/whiteLabel/:whiteLabelId/cms`} component={WhiteLabelDetails} />
        <Route path={`${prefix}/settings/whiteLabel/:whiteLabelId/cms/:cmsId`} component={WhiteLabelCmsDetails} />

        <Route exact path={`${prefix}/settings/whiteLabelPlugin`} component={WhiteLabelPlugin} />
        <Route path={`${prefix}/settings/whiteLabelPlugin/:whiteLabelPluginId`} component={WhiteLabelPluginDetails} />

        <Route exact path={`${prefix}/settings/plugins`} component={Plugins} />
        <Route path={`${prefix}/settings/plugins/:whiteLabelPluginId/sepa`} component={PluginSepaDetails} />
        <Redirect path={`${prefix}/settings/plugins/:whiteLabelPluginId`} to="/:lang/account/settings/plugins" />

        <Route exact path={`${prefix}/settings/leadCatchers`} component={LeadCatchers} />
        <Route path={`${prefix}/settings/leadCatchers/:leadCatcherId`} component={LeadCatcherDetails} />

        <Route path={`${prefix}/settings/integrations`} component={Integrations} />

        <Route
          path={`${prefix}/settings/pluginActivate/:pluginActivationRequestId`}
          component={PluginActivateDetails}
        />

        <Route path={`${prefix}/settings/sepa`} component={SepaAgreements} />

        <Route exact path={`${prefix}/settings/leadPerMailRules`} component={LeadPerMailRules} />
        <Route path={`${prefix}/settings/leadPerMailRules/:leadPerMailRuleId`} component={LeadPerMailRuleDetails} />

        <Route exact path={`${prefix}/settings/failedRefunds`} component={FailedRefunds} />

        <Route exact path={`${prefix}/settings/communities`} component={Communities} />

        <Route exact path={`${prefix}/settings/updates`} component={Updates} />

        <Route exact path={`${prefix}/settings/cmsTemplates`} component={CmsTemplates} />
        <Route path={`${prefix}/settings/cmsTemplates/:cmsTemplateId`} component={CmsTemplateDetails} />

        <Route exact path={`${prefix}/settings/docTemplates`} component={DocTemplates} />
        <Route path={`${prefix}/settings/docTemplates/:docTemplateId`} component={DocTemplateDetails} />

        <Route exact path={`${prefix}/settings/autoresponses`} component={LeadAutoresponses} />
        <Route path={`${prefix}/settings/autoresponses/:autoresponseId`} component={LeadAutoresponseDetails} />

        <Route exact path={`${prefix}/settings/mainMenuVersions`} component={MainMenuVersions} />
        <Route path={`${prefix}/settings/mainMenuVersions/:mainMenuVersionId`} component={MainMenuVersionDetails} />

        <Route exact path={`${prefix}/settings/leadTaggers`} component={LeadTaggers} />
        <Route path={`${prefix}/settings/leadTaggers/:leadTaggerId`} component={LeadTaggerDetails} />

        <Route exact path={`${prefix}/settings/coupons`} component={Coupons} />
        <Route path={`${prefix}/settings/coupons/:couponId`} component={CouponDetails} />

        <Route exact path={`${prefix}/settings/leadAssignmentStrategies`} component={LeadAssignmentStrategies} />
        <Route
          path={`${prefix}/settings/leadAssignmentStrategies/:leadAssignmentStrategyId`}
          component={LeadAssignmentStrategyDetails}
        />

        <Route exact path={`${prefix}/settings/escalationRules`} component={LeadEscalationRules} />
        <Route path={`${prefix}/settings/escalationRules/:escalationRuleId`} component={LeadEscalationRuleDetails} />
      </Switch>
    </Account>
  );
}
